// 📁 Ruta: /var/www/frontend/edutech_react_funcional/src/components/CodigoVerificacionModal.jsx

import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const CodigoVerificacionModal = ({ email, onSuccess, onClose }) => {
  const [codigo, setCodigo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { login } = useAuth(); // ✅ Usar login en lugar de setIsAuthenticated/setUser

  const handleVerificar = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post('/api/verificar-codigo', {
        email,
        codigo
      });

      console.log('🔍 [MODAL] Response status:', response.status);
      console.log('📦 [MODAL] Response data:', response.data);

      // Verificar si la respuesta es exitosa (200-299)
      if (response.status >= 200 && response.status < 300) {
        const { mensaje, token, user } = response.data;

        console.log('✅ [MODAL] Respuesta exitosa');
        console.log('✉️ [MODAL] Mensaje:', mensaje);
        console.log('🔑 [MODAL] Token existe:', !!token);
        console.log('👤 [MODAL] User existe:', !!user);

        // Verificar que tengamos token y user
        if (token && user) {
          console.log('✅ [MODAL] Guardando token y usuario...');
          
          // ✅ Usar la función login del contexto
          login(user, token);

          setSuccess(true);
          console.log('✅ [MODAL] Redirigiendo al dashboard...');
          
          setTimeout(() => {
            onSuccess();
            window.location.href = '/dashboard';
          }, 1000);
        } else {
          console.error('❌ [MODAL] Faltan token o user en la respuesta');
          setError('Error en la respuesta del servidor.');
        }
      }
    } catch (err) {
      console.error('❌ [MODAL] Error capturado:', err);
      console.error('📊 [MODAL] Error response:', err.response);
      
      if (err.response?.status === 410) {
        setError('El código ha expirado. Solicita uno nuevo.');
      } else if (err.response?.status === 401) {
        setError('Código incorrecto. Intenta nuevamente.');
      } else if (err.response?.status === 404) {
        setError('Usuario no encontrado.');
      } else {
        setError('Error al verificar. Intenta más tarde.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
        <h2 className="text-xl font-semibold mb-4">Verifica tu cuenta</h2>
        <p className="text-sm text-gray-500 mb-4">Ingresa el código de 6 dígitos que enviamos a <strong>{email}</strong>.</p>

        <input
          type="text"
          placeholder="Código de verificación"
          maxLength={6}
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
          className="w-full px-4 py-2 border rounded"
        />

        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        {success && <p className="text-green-600 text-sm mt-2">¡Código verificado!</p>}

        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            className="text-gray-600 px-4 py-2 rounded hover:bg-gray-100"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            type="button"
            disabled={loading || codigo.length !== 6}
            onClick={handleVerificar}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
          >
            {loading ? 'Verificando...' : 'Verificar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CodigoVerificacionModal;